// extracted by mini-css-extract-plugin
export default {"RecipeSearchModal":"G89dc73"};